
import { RestrictedAuthenticationModule } from '../modules/authentication/restricted'
import { ErrorModule } from '../modules/error'
import { ModalModule } from '../modules/modal'
// import { ForgotPasswordModule } from '../modules/forgotPassword'
// import { ActivationModule } from '../modules/activation'
// import { ResetPasswordModule } from '../modules/resetPassword'
import { EmailConfirmationModule } from '../modules/emailConfirmation'
import { PersonalDataModule } from '../modules/personalData/puremobile'
// import { PaymentModule } from '../modules/payment'
// import { TopUpModule } from '../modules/topUp'
// import { ChangePassword } from '../modules/changePassword'
// import { EvnModule } from '../modules/evn'
// import { ChangeTariffModule } from '../modules/changeTariff'
// import { ChangePaymentModule } from '../modules/changePayment'
import { TransactionModule } from '../modules/Transaction'
import { ServiceOptionsModule } from '@/store/modules/serviceOptions'
import { CancellationModule } from '@/store/modules/cancel'
// import { SubstituteSimCardModule } from '@/store/modules/substituteSimCard'
// import { BookTariffOptionsModule } from '../modules/bookTariffOptions'
// import { DeactivateTariffOptionsModule } from '../modules/deactivateTariffOptions'
// import { ConsentModule } from '@/store/modules/consent'
// import { ServiceOptionsModule } from '@/store/modules/serviceOptions'

export const storeConfig = {
  modules: {
    Transaction: TransactionModule,
    // resetPassword: ResetPasswordModule,
    authentication: RestrictedAuthenticationModule,
    error: ErrorModule,
    modal: ModalModule,
    // forgotPassword: ForgotPasswordModule,
    // activation: ActivationModule,
    emailConfirmation: EmailConfirmationModule,
    personalData: PersonalDataModule,
    // payment: PaymentModule,
    // topUp: TopUpModule,
    // changePassword: ChangePassword,
    // changePayment: ChangePaymentModule,
    // evn: EvnModule,
    // changeTariff: ChangeTariffModule,
    // substituteSimCard: SubstituteSimCardModule,
    serviceOptions: ServiceOptionsModule,
    // bookTariffOptions: BookTariffOptionsModule,
    // deactivateTariffOptions: DeactivateTariffOptionsModule,
    // consent: ConsentModule,
    cancel: CancellationModule
  },
  actions: {
    clearState ({ commit }) {}
  }
}
